// This file was automatically generated from signin.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.signin');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.signin.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><h3 class="el8BrandColor el8LightWeight el8AlignCenter">View charts sent to your practice via Elation</h3><div class="el8MdSpacer"></div><h4 class="el8AlignCenter el8LightWeight">Welcome, ', soy.$$escapeHtml(opt_data.userProfile.name), '</p><h4 class="el8AlignCenter mbMd">Enter your password</h4><div class="w60p el8CenterBlock"><div class="el8ErrorAlert">Incorrect password</div><div class="el8FormSolo"><form id="main-form"><input type="password" name="password" class="el8StandardInput" placeholder="Password"></input></form></div><div class="el8MdSpacer"></div><button id="go-to-chart" class="el8Btn el8BtnBlock el8BtnPrimary">Go to Chart</button><p class="mtMd el8AlignCenter"><a href="', soy.$$escapeHtml(opt_data.passwordHelpTriageUrl), '">I forgot my password.</a></p></div><div class="el8XLSpacer"></div></div></div>');
  if (!opt_sb) return output.toString();
};
